// ** React Imports
import { useState } from 'react'
import DataTable from 'react-data-table-component'
import { ChevronDown, ChevronRight } from 'react-feather'
import { customExpandableStyles, customMiniStyles } from './addons/CustomStyles'

const noResult = <span style={{ margin: '2%', width: '50%', textAlign: 'center' }}>No se han encontrado resultados</span>
const sortIcon = <ChevronDown size={10} />
const messagePagination = { rowsPerPageText: 'Registros por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }
const limit = [10, 25, 50, 100, 250]

// ** Expandable table component
const ExpandableTable = ({ columns, data, dataChildName, noTableHead = true }) => {
    return <><DataTable
        noTableHead={noTableHead}
        noHeader
        pagination={false}
        responsive
        customStyles={customExpandableStyles}
        sortIcon={sortIcon}
        noDataComponent={noResult}
        columns={columns}
        data={data[dataChildName]}
    /><hr className="w-100 m-0 p-0" /></>
}

export const MiniTable = (props) => {

    const {
        columns,
        data = [],
        paginated = true,
        expandable = false,
        expandableConfig = {},
        dataChildName = 'child'
    } = props

    console.log(data)

    // ** States
    const [currentPage, setCurrentPage] = useState(0)
    const [allExpanded, setAllExpanded] = useState(false)

    const expandAll = () => { setAllExpanded(true) }
    const collapseAll = () => { setAllExpanded(false) }

    return (
        <>
            {expandable && (
                <div className="flex flex-wrap justify-content-end gap-2 py-1 pl-1">
                    {!allExpanded ? (
                        <span className='text-primary cursor-pointer' onClick={expandAll}>
                            <ChevronRight className='mr-1' size={10} />
                            Expandir
                        </span>
                    ) : (
                        <span className='text-primary cursor-pointer' onClick={collapseAll}>
                            <ChevronDown className='mr-1' size={10} />
                            Colapsar
                        </span>
                    )}
                </div>
            )}
            <DataTable
                className='react-dataTable'
                customStyles={expandable ? customExpandableStyles : customMiniStyles}
                responsive
                noHeader
                sortIcon={sortIcon}

                noDataComponent={noResult}

                expandableRows={expandable}
                expandOnRowClicked={false}

                expandableRowExpanded={() => allExpanded}

                expandableRowsComponent={<ExpandableTable {...expandableConfig} data={data} dataChildName={dataChildName} />}

                columns={columns}
                data={data}

                pagination={paginated}
                paginationDefaultPage={currentPage + 1}
                paginationPerPage={25}
                paginationRowsPerPageOptions={limit}
                paginationComponentOptions={messagePagination}
            />
        </>
    )
}